import gql from 'graphql-tag';

export default gql`
    query GetAllLocations($input: GetAllLocationsInput) {
        getAllLocations(input: $input) {
            locationId
            descrip
            locationType
        }
    }
`;
